import { useFormContext } from "react-hook-form";
import AvatarPlaceholder from "@/assets/images/vehicle/avatar-placeholder.svg";
import { Button, Dropzone, Loading, Typography } from "@/components/atoms";
import { useAddAvatarMutation } from "@/redux/apis/vehicle/vehicleApi";
import { Vehicle } from "@/redux/slices/vehicle/types";
import { getAssetUrl } from "@/utils";

export const VehicleImage = ({ vehicle }: { vehicle: Vehicle }) => {
  const [addAvatar, { isLoading }] = useAddAvatarMutation();
  const { setValue, watch } = useFormContext<{ avatar: string }>();
  const avatar = watch("avatar");

  const handleUpload = (file: File) => {
    const formData = new FormData();
    formData.append("avatar", file);

    addAvatar({ id: vehicle.uuid, body: formData })
      .unwrap()
      .then((res) => {
        setValue("avatar", res.avatar, { shouldDirty: true });
      });
  };

  return (
    <Dropzone
      accept={{
        "image/png": [".png"],
        "image/jpeg": [".jpeg", ".jpg"],
      }}
      maxSize={10000000}
      upload={handleUpload}
      className="w-full border-transparent p-5 transition-colors hover:border-neutral-dark-gray"
      detail={
        <div className="relative flex flex-col items-start gap-8 md:flex-row md:items-center">
          {isLoading && <Loading />}
          <img
            src={
              avatar
                ? getAssetUrl(avatar, {
                    width: 200,
                    height: 200,
                    background: "transparent",
                  })
                : AvatarPlaceholder
            }
            alt="Vehicle Image"
            className="h-[100px] w-[100px] grow-0 rounded-full object-contain"
          />
          <div className="flex flex-1 flex-col">
            <Typography variant="action" className="text-black">
              Vehicle Image
            </Typography>
            <Typography className="text-neutral-dark-gray mt-2.5">
              Upload a vehicle image (PNG and JPG supported), we recommend a front view with the Number Plate on it
            </Typography>
            <Button type="button" variant="custom" size="sm" className="mt-0.5 -translate-x-3 self-start text-info">
              Upload
            </Button>
          </div>
        </div>
      }
    />
  );
};
